module.exports = __webpack_public_path__ + "img/6.ed46877a.png";